// ================================================================
// MODAL CONTRAT — À INTÉGRER DANS AffiliateDashboard.js
// ================================================================

// 1. AJOUTER ce state dans le composant (après les useState existants) :
//    const [showContractModal, setShowContractModal] = useState(false);
//    const [contractAccepting, setContractAccepting] = useState(false);
//    const [contractError, setContractError] = useState('');

// 2. AJOUTER dans useEffect après loadData() :
//    if (data.affiliate && !data.affiliate.contract_accepted_at) {
//        setShowContractModal(true);
//    }

// 3. AJOUTER cette fonction dans le composant :
/*
const handleAcceptContract = async () => {
    setContractAccepting(true);
    setContractError('');
    try {
        const config = { headers: { 'Authorization': `Bearer ${token}` } };
        const response = await api.post('/affiliates/accept-contract', {}, config);
        if (response.data.success) {
            setShowContractModal(false);
            // Recharger les données affilié
            await loadData();
        } else {
            setContractError(response.data.message || 'Erreur lors de l\'acceptation');
        }
    } catch (err) {
        setContractError('Erreur réseau — réessaie');
    } finally {
        setContractAccepting(false);
    }
};
*/

// 4. AJOUTER ce JSX AVANT la fermeture </div> finale du return :
const ContractModal = ({ show, onAccept, accepting, error }) => {
    if (!show) return null;

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: 'rgba(0,0,0,0.75)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '20px'
        }}>
            <div style={{
                background: '#0f172a', border: '1px solid #1e293b',
                borderRadius: '16px', maxWidth: '640px', width: '100%',
                maxHeight: '90vh', overflow: 'hidden',
                display: 'flex', flexDirection: 'column'
            }}>
                {/* Header */}
                <div style={{
                    padding: '24px 24px 16px',
                    borderBottom: '1px solid #1e293b',
                    background: 'linear-gradient(135deg,#7C3AED,#4F46E5)',
                }}>
                    <h2 style={{ margin: 0, color: '#fff', fontSize: '18px', fontWeight: 900 }}>
                        📄 Contrat d'affiliation — À lire et accepter
                    </h2>
                    <p style={{ margin: '6px 0 0', color: '#E0D7FF', fontSize: '13px' }}>
                        Tu dois accepter ce contrat pour activer ton programme d'affiliation
                    </p>
                </div>

                {/* Contenu contrat scrollable */}
                <div style={{
                    flex: 1, overflowY: 'auto', padding: '24px',
                    color: '#cbd5e1', fontSize: '13px', lineHeight: '1.7'
                }}>
                    <p style={{ color: '#94a3b8', fontSize: '12px', marginBottom: '20px' }}>
                        Entre <strong style={{ color: '#e2e8f0' }}>Synex Studio</strong> (SIRET 10099299900019, Éditeur) 
                        et <strong style={{ color: '#e2e8f0' }}>vous</strong> (l'Affilié)
                    </p>

                    {[
                        {
                            title: 'Art. 1 — Objet',
                            body: "L'Éditeur confie à l'Affilié la promotion de RizzingBot via un lien de parrainage unique et traçable. L'Affilié s'engage à promouvoir le service de manière honnête et conforme à la réglementation."
                        },
                        {
                            title: 'Art. 2 — Commissions',
                            body: "Commission fixe sur le PREMIER MOIS uniquement :\n• STARTER (5.99$ / 5.49€) → 3€ / $3\n• PREMIUM (11.99$ / 10.99€) → 5.50€ / $5.5\n• PRO (23.99$ / 21.99€) → 12€ / $12\n\nÀ partir du 2ème mois, aucune commission n'est versée."
                        },
                        {
                            title: 'Art. 3 — Paiement',
                            body: "Virement bancaire ou PayPal en fin de mois. Minimum 20€ cumulés requis pour le versement. En dessous, le montant est reporté au mois suivant."
                        },
                        {
                            title: 'Art. 4 — Obligations',
                            body: "Interdictions : publicité mensongère, auto-parrainage, trafic frauduleux, usurpation de la marque RizzingBot. Respect du RGPD obligatoire."
                        },
                        {
                            title: 'Art. 5 — Résiliation',
                            body: "Contrat à durée indéterminée. Résiliation possible à tout moment par l'Éditeur en cas de fraude, non-respect ou inactivité > 6 mois. Commissions dues restent acquises."
                        },
                        {
                            title: 'Art. 6 — Droit applicable',
                            body: "Droit français. Tribunal de Rouen compétent. Solution amiable recherchée avant toute action judiciaire."
                        },
                    ].map((article, i) => (
                        <div key={i} style={{ marginBottom: '16px' }}>
                            <p style={{ color: '#a78bfa', fontWeight: 700, margin: '0 0 4px' }}>
                                {article.title}
                            </p>
                            {article.body.split('\n').map((line, j) => (
                                <p key={j} style={{ margin: '0 0 2px', paddingLeft: line.startsWith('•') ? '12px' : '0' }}>
                                    {line}
                                </p>
                            ))}
                        </div>
                    ))}

                    <div style={{
                        marginTop: '20px', padding: '14px',
                        background: 'rgba(124,58,237,0.15)',
                        border: '1px solid rgba(124,58,237,0.3)',
                        borderRadius: '10px'
                    }}>
                        <p style={{ margin: 0, color: '#c4b5fd', fontSize: '12px' }}>
                            ℹ️ En acceptant, tu recevras par email une copie PDF signée de ce contrat pour tes archives.
                            La date et ton adresse IP seront enregistrées comme preuve d'acceptation.
                        </p>
                    </div>
                </div>

                {/* Footer */}
                <div style={{
                    padding: '16px 24px',
                    borderTop: '1px solid #1e293b',
                    background: '#0b1224'
                }}>
                    {error && (
                        <p style={{ color: '#f87171', fontSize: '13px', marginBottom: '12px' }}>
                            ❌ {error}
                        </p>
                    )}
                    <button
                        onClick={accepting ? undefined : onAccept}
                        disabled={accepting}
                        style={{
                            width: '100%', padding: '14px',
                            background: accepting ? '#4c1d95' : 'linear-gradient(135deg,#7C3AED,#4F46E5)',
                            color: '#fff', border: 'none', borderRadius: '10px',
                            fontSize: '15px', fontWeight: 900, cursor: accepting ? 'not-allowed' : 'pointer',
                            transition: 'opacity 0.2s'
                        }}
                    >
                        {accepting ? '⏳ Enregistrement...' : '✅ J\'accepte les conditions du programme d\'affiliation'}
                    </button>
                    <p style={{ margin: '10px 0 0', color: '#475569', fontSize: '11px', textAlign: 'center' }}>
                        Tu ne pourras pas accéder à ton espace affilié sans accepter ce contrat.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ContractModal;